{
	"config": {
		"missing_entities": "'entities' nicht definiert",
		"missing_names": "'names' nicht definiert",
		"missing_command_topic": "'command_topic' nicht definiert"
	},
	"common": {
		"description": "Eine Karte zum Bearbeiten der Heizprogramme eines Windhager Kessels",
		"missing_entities": "Keine entities definiert",
		"entity_unavailable": "{entity} ist nicht verfügbar.",
		"programme": "Programm",
		"apply": "Anwenden"
	},
	"weekdays": {
		"Mo": "Mo",
		"Tu": "Di",
		"We": "Mi",
		"Th": "Do",
		"Fr": "Fr",
		"Sa": "Sa",
		"Su": "So"
	}
}
